import republicday from "../assets/republicday.webp"
import diwali from "../assets/events/events-01.webp"
import anual from "../assets/anual.webp"
import fancy from "../assets/fancy.webp"
import yoga from "../assets/events/yoga.webp"
import health from "../assets/events/medical.webp"
import studentcouncil from "../assets/studentscouncil.webp"
import speak from "../assets/speak.webp"
import stem from "../assets/stem.webp"
import { FaPhoneAlt } from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import CommonImageSlider from "./comandata"
import { eventImages } from "./data"
import CallandRegisterComponent from "./Callbutton"
import SeoMeta from "./seometa"
import { CommonAboutHeader } from "./CommonAboutHeader"
import ResponsiveImage from "./responsiveimage"
const images = [
  diwali,
  anual,
  fancy,
  yoga,
  health,

speak,



  
];

const seopages = {
    title: "Rankridge Events | Celebrations, Competitions & Achievements",
    description:
      "Explore Rankridge Hyderabad’s events — competitions, celebrations, fests, and achievements that inspire students.",
    keywords: " rankridge events, school celebrations hyderabad, school fests rankridge, rankridge annual day, rankridge sports day, rankridge cultural fest, competitions at rankridge, rankridge student achievements, rankridge academic awards, rankridge school exhibitions, rankridge talent competitions, best school events hyderabad, rankridge art exhibitions, rankridge science fair, inter school competitions hyderabad, rankridge olympiad participation, rankridge debate competitions, student achievement awards rankridge, rankridge cultural programs, memorable events rankridge",
    canonical_path: "https://rankridgeschools.com/events/",
    og_description: "",
    og_image: "",
  };


const title="About Rankridge Junior College"
 const description="School life is made special by the memories children create outside the classroom, and at Rankridge Schools our events play a big part in that journey. From cultural festivals and annual days to sports meets, science fairs, and community celebrations, every event is designed to let children shine in their own way.For parents, these occasions are a chance to see their children grow in confidence, teamwork, and creativity. A child who sings on stage, leads a house team, or presents a project at the exhibition learns lessons no textbook can teach.We believe celebrations build stronger connections between students, families, and teachers. At Rankridge, events are more than activities.they are joyful milestones that shape character, bring families closer, and make school life truly unforgettable."


function Events({status=true}){
const navigate=useNavigate(); 
    return (
       <div className="max-w-7xl mx-auto px-4 mt-4   ">
        <h1 className="text-center text-2xl font-bold">Rankridge Schools Events: Where Learning Meets Celebration</h1>
        <h2 className="text-3xl md:text-4xl  text-center mb-8 mt-4 text-black ">
                {/* Rankridge Provides Specialized Activities */}
               Specialized Skill-Building at Rankridge
              </h2>
       <div className="bg-[#20b2aa]"></div> 
   
           <CommonAboutHeader  images={eventImages} title={title} des={description}/>
     
               {/* <CommonImageSlider images={eventImages} /> */}
                    <h6  className="text-xl text-center text-black font-extrabold mt-6">   Empowering Empathy, Igniting Innovation, Celebrating Creativity.
     </h6>
<section className="w-full bg-white pt-8">
          <CallandRegisterComponent />
             </section>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4 pb-8 ">
        {images.map((src, index) => (
          <div key={index} className="overflow-hidden rounded-xl shadow-lg">
         <ResponsiveImage
  avif={src}
  webp={src}
  srcFallback={src}   // 👈 main fallback
  alt={`Gallery ${index + 1}`}
  eager // eager for LCP
  className="w-full h-auto object-contain transition-transform duration-300 hover:scale-105"
/>
         
            {/* <img
              src={src}
              alt={`Gallery ${index + 1}`}
              className="w-full h-auto object-contain transition-transform duration-300 hover:scale-105"
            /> */}
          </div>
        ))}
      </div>
       
 {status && <SeoMeta seopages={seopages} />}
    </div>
    )
}
export default Events